/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Container, Stack, TextField, Box, TableBody, TableCell, Grid, Tooltip, IconButton, TableHead, TableRow, Table
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@mui/material/TableContainer';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import SearchNotFound from '../../../SearchNotFound';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/styles';
import Collapse from '@material-ui/core/Collapse';
import CheckIcon from '@material-ui/icons/Check';
import { AlertDialog } from './../../Common/AlertDialog';
import _ from 'lodash';

var screenCode = 'GOODSRECEIVEDNOTEAPPROVAL';

export default function GoodsReceivedNoteApproval(props) {

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const classes = useStyles();
    const componentRef = useRef();
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groupList, setGroupList] = useState([]);
    const [groupListTwo, setGroupListTwo] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [operationEntityListTwo, setOperationEntityListTwo] = useState([]);
    const [farmer, setFarmer] = useState([]);
    const [goodDetails, setGoodDetails] = useState([]);
    const [IsApprove, setIsApprove] = useState(false);

    const [approveGoodsReceivedNoteDetails, setApproveGoodsReceivedNoteDetails] = useState();
    const [message, setMessage] = useState("Goods Received Note Approval Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);

    const [approveAllGoodsReceivedNoteDetails, setApproveAllGoodsReceivedNoteDetails] = useState([]);
    const [message2, setMessage2] = useState("All Goods Received Notes Approval Confirmation");
    const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Generate',
        pageheadername: 'Goods Received Note Approval'
    });
    const [date, setDate] = useState(new Date());

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        farmerID: 0,
        dataID: '0'
    });

    const [farmerData, setFarmerata] = useState({
        fullName: "",
        total: 0,
        orderDate: "",
        currentDate: "",
        groupName: "",
        factoryName: "",
        invoiceNo: "",
        orderNo: ""
    });
    const goodsReceivedNoteSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            farmerID: formData.farmerID,
        },

        validationSchema: goodsReceivedNoteSchema,
        onSubmit: (values) => {
            trackPromise(SearchData());
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);


    useEffect(() => {
        trackPromise(GetFarmerDetailsByFactoryIDRouteID());
        setGoodDetails([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setGoodDetails([])
    }, [date]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWGOODSRECEIVEDNOTEAPPROVAL');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        });
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        var groupArray = [];
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
            for (let item of Object.entries(res)) {
                groupArray[item[1]["groupID"]] = item[1]["groupName"]
            }
            setGroupListTwo(groupArray)
        }
    }

    async function GetOperationEntityByGroupID() {
        var factoryArray = [];
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
            for (let item of Object.entries(res)) {
                if (item[1]["factoryType"] === 2) {
                    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
                }
            }
            setOperationEntityListTwo(factoryArray)
        }
    }

    async function GetFarmerDetailsByFactoryIDRouteID() {
        var res = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID)

        if (res != null) {
            setFarmer(res);
        }
    }

    async function SearchData() {
        const Result = await services.GetGoodsReceivedNoteApprovalDetails(formik.values.operationEntityID, new Date(date).toISOString());
        var res = Result.find(x => x.isApproved == false)
        setIsApprove(res == undefined ? false : true)
        setGoodDetails(Result)
    }

    function clearAll() {
        setGoodDetails([])
    }

    function ApproveGoodsReceivedNotePopUp(data) {
        setEnableConfirmMessage(true);
        setApproveGoodsReceivedNoteDetails(data)
    }

    function ApproveAllGoodsReceivedNotePopUp(data) {
        setEnableConfirmMessage2(true);
        setApproveAllGoodsReceivedNoteDetails(data)
    }

    function confirmData(y) {
        if (y) {
            ApproveGoodsReceivedNote(approveGoodsReceivedNoteDetails);
        }
    }

    function confirmData2(y) {
        if (y) {
            ApproveAllGoodsReceivedNote(approveAllGoodsReceivedNoteDetails);
        }
    }

    async function ApproveGoodsReceivedNote(data) {
        let newinitialData = _.cloneDeep(data);
        var nietos = [];
        nietos.push(newinitialData);
        nietos.forEach(x => {
            delete x.driverName
            delete x.gtnNumber
            delete x.packageDetails
            delete x.vehicleNumber
            delete x.isApproved
            x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken())
        })
        var res = await services.UpdateAllGoodsReceivedNoteDetails(nietos)
        if (res.statusCode === "Success") {
            toast.success(res.message);
            trackPromise(SearchData());
        } else {
            toast.error(res.message);
        }
    }

    async function ApproveAllGoodsReceivedNote(data) {
        let newinitialData = _.cloneDeep(data);
        newinitialData.forEach(x => {
            delete x.driverName
            delete x.gtnNumber
            delete x.packageDetails
            delete x.vehicleNumber
            delete x.isApproved
            x.modifiedBy = parseInt(TokenDecoder.getUserIDFromToken())
        })
        var res = await services.UpdateAllGoodsReceivedNoteDetails(newinitialData)
        if (res.statusCode === "Success") {
            toast.success("All Goods Received Notes Approved successfully.");
            trackPromise(SearchData());
        } else {
            toast.error(res.message);
        }
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();

        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align="left">{row.gtnNumber}</TableCell>
                    <TableCell align="left">{row.vehicleNumber}</TableCell>
                    <TableCell align="left">{row.driverName}</TableCell>
                    <TableCell align="left">
                        {row.isApproved == true ?
                            <Chip label="Approved" variant="outlined" color='success' />
                            : <Chip label="Pending" variant="outlined" />}

                    </TableCell>
                    <TableCell align="left">
                        {row.isApproved == false ?
                            <Tooltip title="Approve" >
                                <IconButton aria-label="delete"
                                    onClick={() => ApproveGoodsReceivedNotePopUp(row)}
                                >
                                    <CheckIcon />
                                </IconButton>
                            </Tooltip> : '-'}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 20, paddingTop: 0 }} colSpan={9}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.packageDetails.length != 0 ?
                                <>
                                    {row.packageDetails.map((historyRow) => (
                                        <Card style={{ marginTop: '10px' }}>
                                            <Box margin={1} marginLeft={17}>
                                                <Typography variant="h7" gutterBottom component="div">
                                                    <b>Package Number : {historyRow.packageReferanceNumber}</b>
                                                </Typography>
                                                <Table size="small" aria-label="purchases">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left" style={{ fontWeight: 'bold' }}>SKU</TableCell>
                                                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Crop Name</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Gross QTY</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Deduction QTY</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Net QTY</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {historyRow.groupDetails.map((dataOne) => (
                                                            <TableRow key={dataOne.packageReferanceNumber}>
                                                                <TableCell align="left" component="th" scope="row">
                                                                    {dataOne.productCode}
                                                                </TableCell>
                                                                <TableCell align="left">{dataOne.productName}</TableCell>
                                                                <TableCell align="right">{parseFloat(dataOne.grossAmount).toFixed(2)}</TableCell>
                                                                <TableCell align="right">{parseFloat(dataOne.deduction).toFixed(2)}</TableCell>
                                                                <TableCell align="right">{parseFloat(dataOne.netAmount).toFixed(2)}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </Card>
                                    ))}
                                </>
                                : <Typography variant="h7" gutterBottom component="div">
                                    <b>No Supplier Details</b>
                                </Typography>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Goods Received Note Approval |  FAPS">
                <Container>
                    <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                                        {operationEntityList.map((option) => (
                                            option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Date"
                                            value={date}
                                            onChange={(newValue) => {
                                                setDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('date')}
                                                error={Boolean(touched.date && errors.date)}
                                                helperText={touched.date && errors.date}

                                                {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined" >
                                        Search
                                    </Button>
                                </Stack>
                                <Divider variant="middle" />
                                {goodDetails.length > 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
                                        <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                            <Paper className={classes.root}>
                                                <TableContainer component={Paper}>
                                                    <Table aria-label="collapsible table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell />
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>GTN Number</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Vehicle Number</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Driver Name</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody >
                                                            {goodDetails.map((row) => (
                                                                <Row key={row.gtnid} row={row} />
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="Goods Received Note Approval" />}
                                {goodDetails.length > 0 && IsApprove == true ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button type="button" variant="outlined" color="secondary" onClick={() => ApproveAllGoodsReceivedNotePopUp(goodDetails)}>
                                            Approve All
                                        </Button>
                                    </Stack> : null}
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to approve this Goods Received Note ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
                            discription={"Are you sure want to approve this All Goods Received Notes ?"} setViewPopup={setEnableConfirmMessage2} />
                    </Grid>
                </div>
            </Page>
        </>
    );
}

